import React from 'react';
import {withRouter} from "react-router-dom";
import {Button, Col, FormGroup, Input, Label, Row} from 'reactstrap'
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useEffect, useState} from "react";
import {reorder} from "../../../../utils";


const Checkboxes = (props) => {
  const {field, setField, selected, answerable, formDisabled, fieldNumber} = props
  const {title,description, index, required, details} = field
  const [newOption, setNewOption] = useState('')
  const [addedNew, setAddedNew] = useState(false)

  // Field extra details
  const {options, hasOtherOption} = details

  // Handle re-ordering on dnd
  const onDragEnd = (result) => {

    // dropped outside the list
    if (!result.destination) {
      return
    }

    setField({
      ...field,
      details: {
        ...details,
        options: reorder(
          options,
          result.source.index,
          result.destination.index
        )
      }
    })
  }

  // Helper to set new options
  const setOptions = (newOptions) => {
    setField({
      ...field,
      details: {
        ...details,
        options: newOptions
      }
    })
  }

  // Handle change
  const changeOption = (e,index) => {
    const value = e.target.value
    let newOptions = [...options]
    newOptions[index] = value
    setOptions(newOptions)
  }

  // Handle deletion
  const deleteOption = (index) => {
    let newOptions = [...options]
    newOptions.splice(index,1)
    setOptions(newOptions)
  }

  // Handle addition
  const changeNewOption = (e) => {
    const value = e.target.value
    setNewOption(value)
  }

  // Create new entry on change
  useEffect(()=>{
    if (newOption&&newOption!=='') {
      let newOptions = [...options]
      newOptions.push(newOption)
      setOptions(newOptions)
      setNewOption('')
      setAddedNew(true)
    }
    // eslint-disable-next-line
  },[newOption])

  // Blur when previewing/editing
  useEffect(()=>{
    setAddedNew(false)
  },[selected,answerable])

  // Handle "other" option
  const handleOtherOption = (e) => {
    setField({
      ...field,
      details: {
        ...details,
        hasOtherOption: !hasOtherOption
      }
    })
  }

  const setValue = (optionValue) => {
    const newValue = [...field.value.answers]

    // if it exists, remove from selected
    if (field.value.answers.includes(optionValue)) {
      const optionIndex = field.value.answers.indexOf(optionValue)
      newValue.splice(optionIndex,1)
    } else { // otherwise add
      newValue.push(optionValue)
    }

    // update field
    setField({
      ...field,
      errors: {
        required: answerable&&field.value.length===0&&!!newValue.other
      },
      value: {
        ...field.value,
        answers: newValue
      }
    })
  }
  const setOther = (newValue) => {
    // update field other
    setField({
      ...field,
      errors: {
        required: answerable&&field.value.length===0&&!!newValue.other
      },
      value: {
        ...field.value,
        other: newValue?newValue:null
      }
    })
  }

  const checkErrors = (e) => {
    if (!answerable) return
    if (required) {
      if (field.value.length===0) {
        setField({
          ...field,
          errors: {
            required: true
          }
        })
      }
    }
  }

  // Initialize / fallback for old type of value
  useEffect(()=>{
    if (!field.value.answers) {
      if (field.value.length) {
        setField({...field, value: { answers: field.value, other: null } })
      } else {
        setField({...field, value: { answers: [], other: null } })
      }
    }
    // eslint-disable-next-line
  },[field])

  const requiredError = field.errors&&field.errors.required
  const hasError = requiredError

  // The view / preview part
  //////////////////////////
  if ((!selected) || answerable) return <FormGroup row>
    <Col xs={12}>
    <legend className="col-form-label" style={{fontWeight: 500}}>{fieldNumber+1}. {title} {required&&<b>*</b>}</legend>
    <div style={{fontSize: 12, marginTop: -8, marginBottom: 8, opacity: 0.8}}>{description}</div>
    {options.map((option,i)=><FormGroup check key={i}>
      <Input type="checkbox" name={`checkboxes-${index}-option-${i}`} id={`checkboxes-${index}-option-${i}`}
             checked={field.value.answers&&field.value.answers.includes(option)}
             value={option}
             onChange={()=>setValue(option)}
             onBlur={checkErrors}
             invalid={hasError}
      />
      <Label for={`checkboxes-${index}-option-${i}`} check>{option}</Label>
    </FormGroup>)}
    {hasOtherOption&&<FormGroup style={{marginLeft:20}}>
      <Input type="checkbox" name={`radio-${index}`} id={`radio-${index}`} style={{ marginTop: '0.8rem'}} checked={!!field.value.other} onClick={()=>setField({...field, value: {...field.value,other:null}})}/>

      <Label check >
        <Input type="text" name={`radio-other-${index}`} id={`radio-other-${index}`} placeholder={'Other...'} disabled={formDisabled}
               onBlur={checkErrors}
               invalid={hasError}
               value={field.value.other?field.value.other:''}
               onChange={(e)=>setOther(e.target.value)}
        />
      </Label>
    </FormGroup>}
    </Col>
  </FormGroup>

  // The editor part
  ///////////////////
  return <>
    <h6>Options</h6>
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {options.map((option, optionIndex) => {
              const shouldFocus = addedNew&&optionIndex===options.length-1

              return <Draggable key={`checkboxes-${index}-option-${optionIndex}`} draggableId={`checkboxes-${index}-option-${optionIndex}`} index={optionIndex}>
                {(provided) => (<div key={optionIndex} {...provided.draggableProps} ref={provided.innerRef}>
                    <div style={{position: 'relative', marginBottom: 16}} >

                      <div {...provided.dragHandleProps} style={{color: '#5c5c5c', fontSize: 18, marginBottom: 2, position: 'absolute', left: -18, top: -8}}>
                        <div style={{marginBottom: -22}}><b>..</b></div>
                        <div style={{marginBottom: -22}}><b>..</b></div>
                        <div><b>..</b></div>
                      </div>

                      <div>
                        <Input type="text" name={`checkboxes-${index}-option-${optionIndex}-label`} id={`checkboxes-${index}-option-${optionIndex}-label`} placeholder={'Label'}
                               value={option} onChange={(e)=>changeOption(e,optionIndex)}
                               autoFocus={shouldFocus} disabled={formDisabled}
                        />
                      </div>

                      <div style={{position: 'absolute', right: 0, top: 0}}>
                        <Button outline color="danger" onClick={()=>deleteOption(optionIndex)}>Delete</Button>
                      </div>

                    </div>

                  </div>
                )}
              </Draggable>
            })}
            {provided.placeholder}
          </div>)}
      </Droppable>
    </DragDropContext>

    <div style={{position: 'relative', marginBottom: 16}} >

      <div>
        <Input type="text" name={`new-option`} id={`new-option`} placeholder={'Add new option'} value={newOption} onChange={changeNewOption} />
      </div>

    </div>

    <Row className='justify-content-end text-sm-right'>
      <Col xs={12} sm={4}>
        <Input type="checkbox" name={`multiplechoice-${index}-other}`} id={`multiplechoice-${index}-other`} checked={hasOtherOption} onChange={handleOtherOption} disabled={formDisabled} />
        <Label for={`multiplechoice-${index}-other`} check> Show 'Other' option </Label>
      </Col>
    </Row>
  </>
}

export default withRouter(Checkboxes);
